import React from "react";
import { kebabCase } from "lodash";
import { Helmet } from "react-helmet";
import { Link, graphql } from "gatsby";
import Layout from "../components/Layout";
import SectionTitle from "../components/SectionTitle";
import Pigeon from "../img/pigeon.svg";

const BooksPage = ({ data }) => {
  const books = data.allMdx.edges.filter(
    (edge) => edge.node.frontmatter.isBook
  );
  return (
    <Layout>
      <Helmet>
        <title>Books</title>
      </Helmet>
      <div class="my-32">
        {/* <div class="text-3xl mb-4 font-semibold font-serif">Books</div> */}
        <ul>
          {books.map((edge) => (
            <li key={edge.node.frontmatter.title} class="mb-4">
              <Link
                className="font-serif text-lg hover:underline"
                to={edge.node.fields.slug}
              >
                <span class="text-2xl">{edge.node.frontmatter.title} </span>
                <span class="italic">by </span>
                {edge.node.frontmatter.author}
              </Link>
            </li>
          ))}
        </ul>
        <div class="my-12 h-px" style={{ background: "#bbb" }} />
        <div class="flex-row">
          <img src={Pigeon} class="my-6 w-10" style={{ color: "gray" }} />
        </div>
        <div class="text-gray-600 w-64 text-sm">
          These books are derived from freely available texts which are public
          domain in most countries.
        </div>
      </div>
    </Layout>
  );
};

export default BooksPage;

export const bookPageQuery = graphql`
  query BooksQuery {
    allMdx {
      edges {
        node {
          id
          fields {
            slug
          }
          frontmatter {
            templateKey
            isBook
            date
            title
            description
            author
          }
        }
      }
    }
  }
`;
